import {
  Card,
  CardContent,
  CardHeader,
} from "ui/components/card";
import { Tooltip, TooltipContent, TooltipTrigger } from "ui/components/tooltip";
import { COMMON_CLASSES_FOR_CARD } from "./utils";
import { Link } from "react-router-dom";
import { cn } from "utils";
import { TagBadge } from "components/badge/timesheet-tags";

export default function DraftEntryCard({
  entry,
  href,
  className,
  onClick,
  ...props
}) {
  if (!entry) {
    return null;
  }

  return (
    <Link
      to={href}
      className={cn(className, "cursor-pointer col-span-1")}
      onClick={onClick}
      {...props}
    >
      <Card
        className={cn(
          COMMON_CLASSES_FOR_CARD,
          "h-full",
          className
        )}
      >
        <CardHeader>
          <div className="flex justify-between">
            <div className="font-medium flex items-center gap-2">
              <Tooltip className="!bg-white">
                <TooltipTrigger>
                  {entry.logged_hours ?? 0}hr
                </TooltipTrigger>
                <TooltipContent>Logged</TooltipContent>
              </Tooltip>
              <Tooltip className="!bg-white">
                <TooltipTrigger className="flex items-center gap-2">
                  {entry.tag && (
                    <div className="shrink-0">
                      <TagBadge tag={entry.tag} />
                    </div>
                  )}
                </TooltipTrigger>
                <TooltipContent>Tag</TooltipContent>
              </Tooltip>
            </div>
          </div>
        </CardHeader>
        <CardContent className="-mt-2 flex-1">
          {entry.description && (
            <p className="text-xs whitespace-pre-wrap font-normal line-clamp-3 text-muted-foreground">
              {entry.description}
            </p>
          )}
        </CardContent>
      </Card>
    </Link>
  );
}
